export const BUY_URL = "https://elcometabis.b2c.sisorg.com/home";
export const TRACK_URL = "https://ecb-track-2q26.vercel.app/";
export const EMAIL = "atencionalcliente@elcometabis.com";
export const HORARIO = "8:00 a 21:00 hs";
export const SOCIAL = {
    instagram: "https://www.instagram.com/elcometabis/",
    facebook: "https://www.facebook.com/elcometaenvios/",
};

export const buyLink = (destination) =>
    destination
        ? `${BUY_URL}?destination=${encodeURIComponent(destination)}`
        : BUY_URL;

// Ciudades-cabecera de servicios reales (cards de "A dónde te llevamos").
// La lógica de servicios/recorridos vive en services.js (fuente: Excel).
// La imagen de cada card se puede reemplazar cambiando solo el asset.
export const CARD_DESTINATIONS = [
    { name: "Puerto Iguazú", region: "Misiones", img: "/images/dest-iguazu.webp" },
    { name: "Posadas", region: "Misiones", img: "/images/dest-posadas.webp" },
    { name: "Oberá", region: "Misiones", img: "/images/dest-obera.webp" },
    { name: "Rosario", region: "Santa Fe", img: "/images/dest-rosario.webp" },
    { name: "Clorinda", region: "Formosa", img: "/images/dest-clorinda.webp" },
    { name: "La Plata", region: "Buenos Aires", img: "/images/dest-laplata.webp" },
];

// Boleterías
export const BOLETERIAS = [
    {
        loc: "La Plata",
        name: "Terminal Ómnibus / Boletería 2",
        address: "Calle 41",
        map: "Calle 41, La Plata, Argentina",
    },
    {
        loc: "Cruce Varela",
        name: "Terminal Princess",
        address: "Avenida Calchaquí 686, Berazategui",
        map: "Avenida Calchaquí 686, Berazategui, Cruce Varela, Argentina",
    },
    {
        loc: "Retiro",
        name: "Boletería 139",
        address: "Ramos Mejías 1680, Puente 4",
        map: "Ramos Mejías 1680, Puente 4, Retiro, Argentina",
    },
    {
        loc: "El Talar",
        name: "Bol 44",
        address: "Hipólito Yrigoyen 2338",
        map: "Hipólito Yrigoyen 2338, El Talar, Argentina",
    },
    {
        loc: "Goya",
        name: "Terminal",
        address: "José Gómez y España, Local 5",
        map: "José Gómez y España, Local 5, Goya, Argentina",
    },
    {
        loc: "Bella Vista",
        name: "Terminal",
        address: "9 de Julio y Libertad, Boletería 11",
        map: "9 de Julio y Libertad, Boletería 11, Bella Vista, Argentina",
    },
    {
        loc: "Santa Lucía",
        name: "Terminal",
        address: "Local 3",
        map: "Local 3, Santa Lucía, Argentina",
    },
    {
        loc: "Corrientes",
        name: "Terminal",
        address: "Maipú 2700, Boletería 19",
        map: "Maipú 2700, Boletería 19, Corrientes, Argentina",
    },
];

export const mapLink = (query) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

// FAQ
export const FAQS = [
    {
        q: "¿Cuánto tiempo antes de mi viaje debo llegar?",
        a: "Es necesario presentarse con media hora de anticipación.",
    },
    {
        q: "¿Puedo devolver mi pasaje?",
        a: "La devolución por cancelación varía según el tiempo de anticipación: 90% si es más de 48 horas antes, 80% si es entre 24 y 48 horas antes y 70% si es menos de 24 horas antes.",
    },
    {
        q: "¿Cuál es el equipaje permitido para viajar?",
        a: "Equipaje de mano: 5 kg. Bolsas y valijas: 15 kg.",
    },
];

export const NAV = [
    { label: "Inicio", to: "/" },
    { label: "Buscar Viajes", to: "/buscar-viajes" },
    { label: "Encomiendas", to: "/encomiendas" },
    { label: "Turismo", to: "/turismo" },
    { label: "Boleterías", to: "/boleterias" },
    { label: "Contacto", to: "/contacto" },
];
